<template>
<section class="buildings-map container-fluid" style="padding-left: 0; padding-right: 0">
    <div class="buildings-map__row ">
        <aside class="buildings-map__aside buildings-map-aside" :class="{'buildings-map__aside--open':asideState.visible}">
            <div class="buildings-map-aside__heading">
                <span class="buildings-map-aside__state" v-if="asideState.filters" @click.prevent="toggleAsideState(false,false)">
                     <svg viewBox="0 0 25 25" class="buildings-map-aside__icon buildings-map-aside__icon--menu">
                        <use xlink:href="/assets/site/images/sprites.svg?ver=11#sprite-menu"></use>
                    </svg>
                    Список
                </span>
                <span class="buildings-map-aside__state" v-else @click.prevent="toggleAsideState(true,false)">
                     <svg viewBox="0 0 25 25" class="buildings-map-aside__icon buildings-map-aside__icon--filters">
                        <use xlink:href="/assets/site/images/sprites.svg?ver=11#sprite-filters"></use>
                    </svg>
                    Фильтры
                </span>
                <button class="buildings-map-aside__state buildings-map-aside__state--red buildings-map-aside__state--close btn" @click.prevent="toggleAsideState(true,true,false)">
                        Закрыть
                     <i class="fas fa-times " @click.prevent="toggleAsideState(true,true,false)"></i>
                </button>
            </div>
            <filter-form v-show="asideState.filters" @filterSubmit="filterSubmit" @clearFilter="clearFilter" :options="options" :filtersDisabled="filtersDisabled"></filter-form>
            <list v-show="!asideState.filters" :buildings="buildings" ></list>
        </aside>
        <div class="buildings-map__map ">
            <notifications group="building-map" class="building-map-notify" position="top right">
                <template slot="body" slot-scope="props">
                    <div class="vue-notification">
                        <a class="building-map-notify__title">
                            {{props.item.title}}
                        </a>
                        <a class="building-map-notify__close" @click="props.close">
                            <i class="fa fa-fw fa-close"></i>
                        </a>
                        <div v-html="props.item.text">
                        </div>
                    </div>
                </template>
            </notifications>
            <div id="map-drawing" class="building-map-draw">
                <button class="building-map-draw-btn btn button-rounded button-rounded--orange" id="draw" @click.prevent="drawingState = 'preparing', filtersDisabled=true" v-show="drawingState==='none'">
                    <span class="button-rounded__text building-map-draw-btn__text">
                        Нарисовать область
                    </span>
                    <span class="button-rounded__icon">
                        <svg class="auto-size" xmlns="http://www.w3.org/2000/svg" width="22.83" height="26.03" viewBox="0 0 22.83 26.03">
                          <path fill="currentColor" d="M21.4 13.14a1.95 1.95 0 0 0-.8-.04 1.96 1.96 0 0 0-2.3-1.7 1.95 1.95 0 0 0-2.03-1.55l.56-2.09a1.96 1.96 0 0 0-1.37-2.4 1.96 1.96 0 0 0-2.4 1.38l-2.04 7.53-.94-1.92c0-.02 0-.03-.02-.04a1.96 1.96 0 0 0-2.67-.74c-.8.46-1.08 1.38-.78 2.52.38 1.48.85 2.9 1.26 4.16.3.92.58 1.79.77 2.5.16.6.51 2.54.52 2.56.04.25.23.45.47.52L17.7 26c.28.07.58-.04.73-.28.28-.43 2.72-4.22 3.15-5.82l1.18-4.36a1.96 1.96 0 0 0-1.37-2.4zm-1.13 1.74c.09-.35.44-.55.78-.46.33.09.53.44.44.79l-1.18 4.35c-.29 1.07-1.88 3.71-2.73 5.05l-7.2-1.95a43.7 43.7 0 0 0-.46-2.26c-.2-.74-.49-1.62-.8-2.56-.4-1.24-.86-2.64-1.23-4.08-.1-.38-.15-.86.16-1.04a.65.65 0 0 1 .86.23l1.7 3.48a.66.66 0 0 0 1.23-.12l2.5-9.22c.09-.35.44-.55.77-.46.34.09.54.44.45.79l-1.62 5.95a.66.66 0 0 0 1.28.35l.56-2.07c.1-.35.44-.55.78-.46.34.1.54.45.44.79l-.78 2.9a.66.66 0 0 0 1.27.35l.56-2.07c.1-.35.45-.55.78-.46.34.09.54.44.44.79l-.78 2.9a.66.66 0 0 0 1.28.34l.5-1.85zM8.56.1a.62.62 0 0 0-.18.86l1.23 1.9a8.06 8.06 0 0 0-8.3 12.3.62.62 0 0 0 1.04-.67A6.83 6.83 0 0 1 9.8 4.16L7.99 6.43a.62.62 0 1 0 .97.77l2.45-3.06c.17-.21.18-.5.04-.73L9.42.28A.62.62 0 0 0 8.56.1z"></path>
                        </svg>
                    </span>
                </button>
                <button class="building-map-draw-btn btn button-rounded button-red" id="draw-cancel" v-show="drawingState === 'preparing' || drawingState === 'drawing'" @click.prevent="drawingState='none', filtersDisabled = false">
                    <span class="button-rounded__text building-map-draw-btn__text">
                         Закрыть
                    </span>
                   <i class="fas fa-times"></i>
                </button>
                <button class="btn building-map-draw-btn button-rounded button-red" id="refresh-polygon" v-show="drawingState ==='polygon'" @click.prevent="drawingState='none', filtersDisabled = false">
                    <span class="button-rounded__text building-map-draw-btn__text">
                        Сбросить область
                    </span>
                    <i class="fas fa-trash-alt"></i>
                </button>
            </div>
            <yandex-map  :settings="settings" :coords="mapSettings.position" :zoom="mapSettings.zoom"
                        :controls="[]"
                        @map-was-initialized="initHandler"
                         @boundschange="changeZoom"
                      >

            </yandex-map>
            <canvas id="draw-canvas" style="position: absolute; left: 0; top: 0; display: none;"></canvas>
            <div class="building-map-draw-overlay" id="draw-overlay" style="display: none" v-show="drawingState === 'preparing'">
                <div class="building-map-draw-overlay__icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="49.38" height="56.3" viewBox="0 0 22.83 26.03">
                        <path fill="currentColor" d="M21.4 13.14a1.95 1.95 0 0 0-.8-.04 1.96 1.96 0 0 0-2.3-1.7 1.95 1.95 0 0 0-2.03-1.55l.56-2.09a1.96 1.96 0 0 0-1.37-2.4 1.96 1.96 0 0 0-2.4 1.38l-2.04 7.53-.94-1.92c0-.02 0-.03-.02-.04a1.96 1.96 0 0 0-2.67-.74c-.8.46-1.08 1.38-.78 2.52.38 1.48.85 2.9 1.26 4.16.3.92.58 1.79.77 2.5.16.6.51 2.54.52 2.56.04.25.23.45.47.52L17.7 26c.28.07.58-.04.73-.28.28-.43 2.72-4.22 3.15-5.82l1.18-4.36a1.96 1.96 0 0 0-1.37-2.4zm-1.13 1.74c.09-.35.44-.55.78-.46.33.09.53.44.44.79l-1.18 4.35c-.29 1.07-1.88 3.71-2.73 5.05l-7.2-1.95a43.7 43.7 0 0 0-.46-2.26c-.2-.74-.49-1.62-.8-2.56-.4-1.24-.86-2.64-1.23-4.08-.1-.38-.15-.86.16-1.04a.65.65 0 0 1 .86.23l1.7 3.48a.66.66 0 0 0 1.23-.12l2.5-9.22c.09-.35.44-.55.77-.46.34.09.54.44.45.79l-1.62 5.95a.66.66 0 0 0 1.28.35l.56-2.07c.1-.35.44-.55.78-.46.34.1.54.45.44.79l-.78 2.9a.66.66 0 0 0 1.27.35l.56-2.07c.1-.35.45-.55.78-.46.34.09.54.44.44.79l-.78 2.9a.66.66 0 0 0 1.28.34l.5-1.85zM8.56.1a.62.62 0 0 0-.18.86l1.23 1.9a8.06 8.06 0 0 0-8.3 12.3.62.62 0 0 0 1.04-.67A6.83 6.83 0 0 1 9.8 4.16L7.99 6.43a.62.62 0 1 0 .97.77l2.45-3.06c.17-.21.18-.5.04-.73L9.42.28A.62.62 0 0 0 8.56.1z"></path>
                    </svg>
                </div>
                <div class="building-map-draw-overlay__text">
                    Нарисуйте область
                    <br>
                    на карте
                </div>
            </div>
            <div class="buildings-map__filter-btn-group">
                <button class="buildings-map__filter-btn buildings-map__filter-btn--red btn " @click.prevent="toggleAsideState(true, true, true)">
                    <svg viewBox="0 0 25 25" class="buildings-map-aside__icon buildings-map-aside__icon--filters">
                        <use xlink:href="/assets/site/images/sprites.svg?ver=11#sprite-filters"></use>
                    </svg>
                    Фильтры
                </button>
                <button class="buildings-map__filter-btn btn" @click.prevent="toggleAsideState( false,true, true)">
                    <svg viewBox="0 0 25 25" class="buildings-map-aside__icon buildings-map-aside__icon--menu">
                        <use xlink:href="/assets/site/images/sprites.svg?ver=11#sprite-menu"></use>
                    </svg>
                    Список
                </button>
            </div>
        </div>
    </div>

</section>
</template>
<script>
    import form from "./form";
    import list from "./list";
    import balloon from "./balloon";
    import { yandexMap, ymapMarker } from 'vue-yandex-maps';
    export default {
        components: {
            'filter-form':form, list, yandexMap, ymapMarker, balloon
        },
        computed: {

        },
        props:['options'],
        data() {
            return {
                filtersDisabled:false,
                asideState: {
                    filters:true,
                    visible:false,
                },
                oldBuildings:[],
                oldPolygons:[],
                map:{},
                polygons:[],
                mapSettings: {
                    position:[54.730297082939394,56.037724499999975],
                    zoom:11,
                },
                settings:{
                    apiKey: 'fbdcc52a-7ad9-4d51-bf5e-7c2cfcf1d3e2',
                    lang: 'ru_RU',
                    version: '2.1'
                },
                buildings:[],
                zoomState: 0,
                canvasOptions: {
                    strokeStyle: '#0000ff',
                    lineWidth: 4,
                    opacity: 0.7
                },
                polygonOptions:{
                    strokeColor: '#0000ff',
                    fillColor: '#8080ff',
                    interactivityModel: 'default#transparent',
                    strokeWidth: 4,
                    opacity: 0.7
                },
                drawingState: "none",
            }
        },
        methods: {
            initHandler: function(map) {
                this.map = map;
                //map.setBounds(map.geoObjects.getBounds());
                // Создадим пользовательский макет ползунка масштаба.
                const ZoomLayout =  ymaps.templateLayoutFactory.createClass("<div class='buildings-map__zoom-controls'>" +
                    "<div id='zoom-in' class='buildings-map__btn'><i class='fas fa-plus'></i></div>" +
                    "<div id='zoom-out' class='buildings-map__btn'><i class='fas fa-minus'></i></div>" +
                    "</div>", {

                    // Переопределяем методы макета, чтобы выполнять дополнительные действия
                    // при построении и очистке макета.
                    build: function () {
                        // Вызываем родительский метод build.
                        ZoomLayout.superclass.build.call(this);

                        // Привязываем функции-обработчики к контексту и сохраняем ссылки
                        // на них, чтобы потом отписаться от событий.
                        this.zoomInCallback = ymaps.util.bind(this.zoomIn, this);
                        this.zoomOutCallback = ymaps.util.bind(this.zoomOut, this);

                        // Начинаем слушать клики на кнопках макета.
                        $('#zoom-in').bind('click', this.zoomInCallback);
                        $('#zoom-out').bind('click', this.zoomOutCallback);
                    },

                    clear: function () {
                        // Снимаем обработчики кликов.
                        $('#zoom-in').unbind('click', this.zoomInCallback);
                        $('#zoom-out').unbind('click', this.zoomOutCallback);

                        // Вызываем родительский метод clear.
                        ZoomLayout.superclass.clear.call(this);
                    },

                    zoomIn: function () {
                        var map = this.getData().control.getMap();
                        map.setZoom(map.getZoom() + 1, {checkZoomRange: true});
                    },

                    zoomOut: function () {
                        var map = this.getData().control.getMap();
                        map.setZoom(map.getZoom() - 1, {checkZoomRange: true});
                    }
                });
                const zoomControl = new ymaps.control.ZoomControl({options: {layout: ZoomLayout}});
                map.controls.add(zoomControl);
                let buildings = this.buildings;
                let coords = buildings.map(function(building){
                    let item = {};
                    item.latitude = parseFloat(building.map.latitude);
                    item.longitude = parseFloat(building.map.longitude);
                    return item;
                });
                var polygon = null;

                var drawButton = document.querySelector('#draw');
                let _this = this;
                drawButton.onclick = function() {
                   // drawButton.disabled = true;

                    _this.drawLineOverMap(map)
                        .then(function(coordinates) {
                            // Переводим координаты из 0..1 в географические.
                            var bounds = map.getBounds();
                            coordinates = coordinates.map(function(x) {
                                return [
                                    // Широта (latitude).
                                    // Y переворачивается, т.к. на canvas'е он направлен вниз.
                                    bounds[0][0] + (1 - x[1]) * (bounds[1][0] - bounds[0][0]),
                                    // Долгота (longitude).
                                    bounds[0][1] + x[0] * (bounds[1][1] - bounds[0][1]),
                                ];
                            });

                            // Тут надо симплифицировать линию.
                            // Для простоты я оставляю только каждую третью координату.
                            coordinates = coordinates.filter(function (_, index) {
                                return index % 3 === 0;
                            });

                            // Удаляем старый полигон.
                            if (polygon) {
                                map.geoObjects.remove(polygon);
                            }

                            // Создаем новый полигон
                            polygon = new ymaps.Polygon([coordinates], {}, _this.polygonOptions);
                            map.geoObjects.add(polygon);
                            let buildings = _this.buildings.filter(function(item){
                                return polygon.geometry.contains([item.map.latitude, item.map.longitude])
                            });
                            let building_ids = buildings.map(function (item) {
                               return item.id
                            });
                            console.log(building_ids)
                            let polygons = _this.polygons.filter(function (item) {
                                return building_ids.indexOf(item.building_id) != -1
                            });
                            console.log(polygons);
                            _this.oldBuildings = _this.buildings;
                            _this.oldPolygons = _this.polygons;
                            _this.buildings = buildings;
                            _this.polygons = polygons;
                            console.log(_this.polygons);
                            _this.drawingState = 'polygon';
                            drawButton.disabled = false;
                        });
                };
                var cancelButton = document.querySelector("#draw-cancel");
                cancelButton.onclick = function () {
                    _this.drawingState = 'none';
                    if(polygon) {
                        map.geoObjects.remove(polygon);
                    }
                    var canvas = document.querySelector('#draw-canvas');
                    canvas.style.display = 'none';
                };
                var refreshPolygon = document.querySelector('#refresh-polygon');
                refreshPolygon.onclick= function () {
                    _this.drawingState = 'none';
                    if(polygon) {
                        map.geoObjects.remove(polygon);
                    }
                    _this.buildings = _this.oldBuildings;
                    _this.polygons = _this.oldPolygons;
                };

            },
            toggleAsideState(asideFilter, changeAsideState, asideVisible) {
                this.asideState.filters = asideFilter;
                if(changeAsideState) {
                    this.asideState.visible = asideVisible;
                }


            },
            getBuildings() {
                axios.get('/api/buildings/map')
                    .then((response) => {
                        this.buildings = response.data;
                    })
            },
            filterSubmit(form) {
                axios.get('/api/buildings/map', { params: form})
                    .then((response) => {
                        this.buildings = response.data.buildings;
                        this.polygons = response.data.polygons;
                        if(this.buildings.length > 0) {
                            this.$notify({
                                group: 'building-map',
                                title: 'Подобрано объектов - ' + this.buildings.length,
                            });
                        }

                    })
            },
            changeZoom(e) {
                let _this = this;
                if (e.get('newZoom') !== e.get('oldZoom')) {
                   _this.zoomState = (e.get('newZoom'));
                }
            },
            clearFilter() {
                this.getBuildings();
            },
            drawLineOverMap(map) {
                var canvas = document.querySelector('#draw-canvas');
                var ctx2d = canvas.getContext('2d');
                var drawing = false;
                var coordinates = [];

                // Задаем размеры канвасу как у карты.
                var rect = map.container.getParentElement().getBoundingClientRect();
                console.log(rect);
                canvas.style.width = rect.width + 'px';
                canvas.style.height = rect.height + 'px';
                canvas.width = rect.width;
                canvas.height = rect.height;

                // Применяем стили.
                ctx2d.strokeStyle = this.canvasOptions.strokeStyle;
                ctx2d.lineWidth = this.canvasOptions.lineWidth;
                canvas.style.opacity = this.canvasOptions.opacity;

                ctx2d.clearRect(0, 0, canvas.width, canvas.height);

                // Показываем канвас. Он будет сверху карты из-за position: absolute.
                canvas.style.display = 'block';
                let _this = this;
                canvas.onmousedown = function(e) {
                    // При нажатии мыши запоминаем, что мы начали рисовать и координаты.
                    _this.drawingState = 'drawing';
                    drawing = true;
                    coordinates.push([e.offsetX, e.offsetY]);
                };

                canvas.onmousemove = function(e) {
                    // При движении мыши запоминаем координаты и рисуем линию.
                    if (drawing) {
                        var last = coordinates[coordinates.length - 1];
                        ctx2d.beginPath();
                        ctx2d.moveTo(last[0], last[1]);
                        ctx2d.lineTo(e.offsetX, e.offsetY);
                        ctx2d.stroke();

                        coordinates.push([e.offsetX, e.offsetY]);
                    }
                };

                return new Promise(function(resolve) {
                    // При отпускании мыши запоминаем координаты и скрываем канвас.
                    canvas.onmouseup = function(e) {
                        coordinates.push([e.offsetX, e.offsetY]);
                        canvas.style.display = 'none';
                        drawing = false;

                        coordinates = coordinates.map(function(x) {
                            return [x[0] / canvas.width, x[1] / canvas.height];
                        });

                        resolve(coordinates);
                    };
                });
            }

        },
        mounted() {
            axios.get('/api/buildings/map', {params:this.options})
                .then((response) => {
                    this.buildings = response.data.buildings;
                    this.polygons = response.data.polygons;
                })
        },


    }
</script>
